import { styled } from '@linaria/react';

import Demo, {
  DemoOutputWrapper,
  DemoRadioControl,
} from '@/components/Demo';

function ShadowComparisonDemo() {
  return (
    <Demo
      id="shadow-comp"
      initialValues={{ mode: 'filter' }}
      outputWrapper={OutputWrapper}
      controls={[
        <DemoRadioControl
          key="mode"
          id="mode"
          label="Shadow"
          options={['filter', 'box-shadow', 'none']}
        />,
      ]}
    >
      {({ mode }) => {
        const filter =
          mode === 'filter'
            ? `
            drop-shadow(2px 4px 8px hsl(220deg 60% 50% / 0.44))
            drop-shadow(4px 8px 16px hsl(220deg 60% 50% / 0.44))
            drop-shadow(8px 16px 32px hsl(220deg 60% 50% / 0.44))
          `
            : '';
        const boxShadow =
          mode === 'box-shadow'
            ? `
            2px 4px 8px hsl(220deg 60% 50% / 0.44),
            4px 8px 16px hsl(220deg 60% 50% / 0.44),
            8px 16px 32px hsl(220deg 60% 50% / 0.44)
          `
            : '';

        return (
          <Wrapper
            style={{ filter, boxShadow }}
            key={filter + boxShadow}
          >
            <Image
              alt="3D illustration of a scared ghost"
              src="/images/designing-shadows/ghost-transparent.png"
            />
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  will-change: transform;
`;

const Image = styled.img`
  display: block;
  width: calc(377px / 2);
  height: calc(598px / 2);
`;

const OutputWrapper = styled(DemoOutputWrapper)`
  background-color: hsl(220deg 100% 80%);
`;

export default ShadowComparisonDemo;
